import { Lounge } from '@utils/types';
import { axiosInstance } from '.';

export const getCitiesApi = async (): Promise<string[]> => {
  const { data: res } = await axiosInstance.get('/v1/lounge/get-cities');

  return res.data.cities;
};

export const getLoungesApi = async (city: string): Promise<Lounge[]> => {
  const { data: res } = await axiosInstance.get(
    `/v1/lounge/get-city-lounges/${city}`,
  );

  return res.data.lounges;
};
